import { usePlanIsUnchangeable as useIsUnchangeable } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-unchangeable/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsUnchangeable = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isUnchangeable } = viewModel;

	return useIsUnchangeable({ isUnchangeable, onSetViewModel });
};
